import React, {Component, PropTypes} from 'react'
import {Row, Col, PageHeader} from 'react-bootstrap'
import UpdateUserCard from './UpdateUserCard'
import ResetLoginDemandCard from './ResetLoginDemandCard'
import ResetPasswordDemandCard from './ResetPasswordDemandCard'
import UserConfigsCard from './UserConfigsCard'
import i18n from '../i18n'

class AccountDetail extends Component {
    static propTypes = {
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm={8}>
                        <PageHeader className='large'>{i18n.manageAccount}</PageHeader>
                        <UpdateUserCard />
                        <ResetLoginDemandCard />
                        <ResetPasswordDemandCard />
                        <UserConfigsCard />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default AccountDetail


// WEBPACK FOOTER //
// ./lib/user/components/AccountDetail.js